import { connect } from 'react-redux'
import OfferLetter from 'modules/OfferLetter/index'
import selector from 'modules/OfferLetter/selectors'
import {
  getOfferList,
  OfferAcceptReject,
  getOfferMetric,
  getUserCorpList,
  candidateJoined,
} from 'modules/OfferLetter/actions'
import {
  getNotificationCatalogues,
  sendNotificationEmail,
  sendNotificationBulkEmail,
  sendInAppNotification
} from 'modules/ManageProfile/actions'
import authSelectors from 'modules/Auth/selectors'
import { getStudentData } from 'modules/Resume/actions'
import selectorOB from 'modules/Onboarding/selectors'

const mapStateToProps = state => ({
  offerLetterList: selector.getOfferLetterData(state),
  offerMetric: selector.getOfferMetric(state),
  permissions: authSelectors.getUserPermissions(state),
  studentDetails: selectorOB.getStudentResumeData(state),
})

const mapDispatchToProps = {
  getOfferList,
  OfferAcceptReject,
  getOfferMetric,
  getUserCorpList,
  getNotificationCatalogues,
  sendNotificationEmail,
  sendNotificationBulkEmail,
  getStudentData,
  candidateJoined,
  sendInAppNotification
}

export default connect(mapStateToProps, mapDispatchToProps)(OfferLetter)
